// Modal: crear tarea CRM desde el detalle de una orden (kanban)
// Pre-carga título y descripción con el contexto de la orden y la deja linkeada
// a la orden (orden_id) y al cliente (cliente_id).
import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";

const BASE = process.env.REACT_APP_API_BASE || "http://localhost/twinpack/php";

const ctxOrden = (orden) => {
  const monto = orden.monto_total
    ? `${orden.moneda === "USD" ? "USD " : "$"}${parseFloat(orden.monto_total).toLocaleString("es-AR")}`
    : "—";
  const lineas = [
    `Orden #${orden.id} — ${orden.cliente || "—"}`,
    orden.proveedor ? `Proveedor: ${orden.proveedor}` : null,
    orden.estado_actual ? `Estado: ${orden.estado_actual}` : null,
    `Monto: ${monto}`,
  ].filter(Boolean);
  return lineas.join("\n") + "\n\n";
};

const OrdenTareaModal = ({ orden, userId, onClose }) => {
  const [titulo,      setTitulo]      = useState(`Seguimiento OC #${orden.id} — ${orden.cliente || ""}`.trim());
  const [vencimiento, setVencimiento] = useState("");
  const [descripcion, setDescripcion] = useState(ctxOrden(orden));
  const [submitting,  setSubmitting]  = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!titulo.trim())  return toast.error("El título es obligatorio");
    if (!vencimiento)    return toast.error("La fecha es obligatoria");

    setSubmitting(true);
    try {
      const fd = new FormData();
      fd.append("titulo",      titulo.trim());
      fd.append("vencimiento", vencimiento);
      fd.append("descripcion", descripcion.trim());
      fd.append("tipo",        "seguimiento");
      fd.append("prioridad",   "media");
      fd.append("estado",      "pendiente");
      fd.append("usuario_id",  userId);
      fd.append("orden_id",    orden.id);
      if (orden.cliente_id) fd.append("cliente_id", orden.cliente_id);

      const r = await axios.post(`${BASE}/tareas_guardar.php`, fd);
      if (r.data?.success) {
        toast.success("✓ Tarea creada");
        onClose();
      } else {
        toast.error(r.data?.mensaje || "Error al crear la tarea");
        setSubmitting(false);
      }
    } catch {
      toast.error("Error de conexión");
      setSubmitting(false);
    }
  };

  return (
    <div style={overlay} onClick={onClose}>
      <div style={modal} onClick={(e) => e.stopPropagation()}>
        <h2 style={{ margin: "0 0 6px", fontSize: 18, fontWeight: 700, color: "#9f0059" }}>
          📅 Crear tarea desde la orden
        </h2>
        <p style={{ margin: "0 0 20px", fontSize: 13, color: "#888" }}>
          Quedará linkeada a la orden y aparecerá en CRM → Tareas y en el calendario.
        </p>

        <form onSubmit={handleSubmit}>
          <div style={field}>
            <label style={label}>Título</label>
            <input style={inp} value={titulo} onChange={(e) => setTitulo(e.target.value)} autoFocus />
          </div>

          <div style={field}>
            <label style={label}>Fecha de vencimiento *</label>
            <input
              type="date"
              style={inp}
              value={vencimiento}
              onChange={(e) => setVencimiento(e.target.value)}
              min={new Date().toISOString().split("T")[0]}
            />
          </div>

          <div style={field}>
            <label style={label}>Descripción</label>
            <textarea
              style={{ ...inp, minHeight: 96, resize: "vertical", fontFamily: "inherit" }}
              value={descripcion}
              onChange={(e) => setDescripcion(e.target.value)}
              placeholder="Contexto de la orden + lo que haya que hacer…"
            />
          </div>

          <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 20, paddingTop: 16, borderTop: "1.5px solid #f0e6ec" }}>
            <button type="button" onClick={onClose} style={btnSecondary} disabled={submitting}>Cancelar</button>
            <button type="submit" style={btnPrimary} disabled={submitting}>
              {submitting ? "Creando…" : "Crear tarea"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

const overlay = { position: "fixed", top: 0, left: 0, right: 0, bottom: 0, background: "rgba(0,0,0,0.45)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1100, padding: 20 };
const modal = { background: "#fff", borderRadius: 14, padding: "26px 30px", maxWidth: 480, width: "100%", boxShadow: "0 8px 32px rgba(0,0,0,0.18)" };
const inp = { width: "100%", padding: "9px 12px", border: "1.5px solid #e0d6dc", borderRadius: 8, fontSize: 13, color: "#222", background: "#fafafa", outline: "none", boxSizing: "border-box", fontFamily: "inherit" };
const field = { marginBottom: 14 };
const label = { display: "block", fontSize: 11, fontWeight: 700, color: "#888", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: 4 };
const btnPrimary = { padding: "10px 22px", background: "#9f0059", color: "#fff", border: "none", borderRadius: 8, fontSize: 13, fontWeight: 700, cursor: "pointer" };
const btnSecondary = { padding: "10px 22px", background: "#fff", color: "#666", border: "1.5px solid #e0d6dc", borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: "pointer" };

export default OrdenTareaModal;
